import {Injectable} from '@angular/core';
import {CrudService, deserialize, JsonApiResponse} from '@tisa-group/cdk';
import {UmpireCurrentClient} from '@tisa-group/models';
import {map, Observable} from 'rxjs';
import {TisaUmpireHttpService} from '../tisa-umpire-http.service';

@Injectable({
  providedIn: 'root',
})
export class CurrentClientService implements CrudService<UmpireCurrentClient> {
  constructor(readonly http: TisaUmpireHttpService) {}

  fetch(): Observable<JsonApiResponse<UmpireCurrentClient>> {
    return this.http.get(`/current_client`).pipe(
      deserialize(),
      map(response => {
        const config = response as JsonApiResponse<UmpireCurrentClient>;
        // hotfix for incorrect link
        if (
          config.data.config?.external_dependencies?.wicket?.frontend_url ===
          'https://ekstraklasa.tisa-wicket.com'
        ) {
          config.data.config.external_dependencies.wicket.frontend_url =
            'https://konto.ekstraklasa.tv';
        }
        if (
          config.data.config?.external_dependencies?.wicket?.frontend_url ===
          'https://legia.tisa-wicket.com'
        ) {
          config.data.config.external_dependencies.wicket.frontend_url =
            'https://konto.legia.com';
        }

        if (
          config.data.config?.external_dependencies?.wicket?.images_url ===
          's3.eu-central-1.amazonaws.com/wicket-upload-cement'
        ) {
          config.data.config.external_dependencies.wicket.images_url =
            's3.eu-central-1.amazonaws.com/wicket-upload-cement-prod';
        }
        return config;
      }),
    );
  }
}
